/* NOTE: this module no longer creates a supabase-js client, and the web no */
/* longer calls any Supabase Edge Function. It only exposes `requireSession`, */
/* which reads the backend-issued session (lib/session). supabase-js lives ONLY */
/* in apps/api now. */
import { getAccessToken, getSession } from './session';

/** Current session (backend-issued) or throw 'Not authenticated'. Refreshes the
 *  access token if it's near expiry. */
export async function requireSession(): Promise<{ access_token: string; user: { id: string } }> {
  const token = await getAccessToken();
  const s = getSession();
  if (!token || !s) throw new Error('Not authenticated');
  return { access_token: token, user: { id: s.user.id } };
}
